import { useRef, useState } from "react";
import { Camera, X } from "lucide-react";
import { api, BACKEND_URL } from "../lib/api";
import { toast } from "sonner";

export default function PhotoUploader({ photoIds = [], onChange, max = 6, label = "Bilder" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (files) => {
    if (!files?.length) return;
    setUploading(true);
    const next = [...photoIds];
    for (const f of Array.from(files)) {
      if (next.length >= max) break;
      try {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/files/upload", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        next.push(data.id);
      } catch (e) {
        toast.error("Kunne ikke laste opp bilde");
      }
    }
    onChange(next);
    setUploading(false);
  };

  const removeAt = (idx) => {
    const next = [...photoIds];
    next.splice(idx, 1);
    onChange(next);
  };

  return (
    <div data-testid="photo-uploader" className="space-y-2">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#A57F39]">{label}</div>
      <div className="flex flex-wrap gap-2">
        {photoIds.map((id, idx) => (
          <div key={id} className="relative w-20 h-20 rounded-lg overflow-hidden border border-[#E2E8F0] bg-slate-50">
            <img
              src={`${BACKEND_URL}/api/files/${id}`}
              className="w-full h-full object-cover"
              alt=""
            />
            <button
              type="button"
              data-testid={`photo-remove-${idx}`}
              onClick={() => removeAt(idx)}
              className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-0.5"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
        {photoIds.length < max && (
          <button
            type="button"
            data-testid="photo-add-button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            className="w-20 h-20 rounded-lg border-2 border-dashed border-[#BD984D]/40 flex flex-col items-center justify-center text-[#A57F39] hover:bg-[#BD984D]/5 transition"
          >
            <Camera className="w-5 h-5" />
            <span className="text-[10px] mt-1">{uploading ? "..." : "Legg til"}</span>
          </button>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        multiple
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
      />
    </div>
  );
}
